import { alpha } from '@material-ui/core/styles'; // ----------------------------------------------------------------------

var createGradient = function createGradient(color1, color2) {
  return "linear-gradient(to bottom, ".concat(color1, ", ").concat(color2, ")");
};

var PRIMARY = {
  lighter: '#F8DFEC',
  light: '#D998C4',
  main: '#824179',
  dark: '#5A205D',
  darker: '#320C3E'
};
var SECONDARY = {
  lighter: '#D6E4FF',
  light: '#84A9FF',
  main: '#3366FF',
  dark: '#1939B7',
  darker: '#091A7A'
};
var INFO = {
  lighter: '#C7F9EA',
  light: '#59E0CE',
  main: '#009399',
  dark: '#00576E',
  darker: '#002D49'
};
var SUCCESS = {
  lighter: '#EEF9CC',
  light: '#B7DC65',
  main: '#5B8C0E',
  dark: '#386407',
  darker: '#1F4302'
};
var WARNING = {
  lighter: '#FAEDCA',
  light: '#E6B360',
  main: '#AD5E05',
  dark: '#7C3702',
  darker: '#531C00'
};
var ERROR = {
  lighter: '#FBE2D4',
  light: '#EC907D',
  main: '#C12A2A',
  dark: '#8A1529',
  darker: '#5C0825'
};
var GREY = {
  0: '#FFFFFF',
  50: '#F9FAFB',
  A100: '#F9FAFB',
  A200: '#F4F6F8',
  A400: '#C4CDD5',
  A700: '#454F5B',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  5008: alpha('#919EAB', 0.08),
  50012: alpha('#919EAB', 0.12),
  50016: alpha('#919EAB', 0.16),
  50024: alpha('#919EAB', 0.24),
  50032: alpha('#919EAB', 0.32),
  50048: alpha('#919EAB', 0.48),
  50056: alpha('#919EAB', 0.56),
  50080: alpha('#919EAB', 0.8)
};
var GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main)
};
export var Palette = {
  // LIGHT
  light: {
    mode: 'light',
    primary: {
      lighter: PRIMARY.lighter,
      light: PRIMARY.light,
      main: PRIMARY.main,
      dark: PRIMARY.dark,
      darker: PRIMARY.darker,
      contrastText: '#fff'
    },
    secondary: {
      lighter: SECONDARY.lighter,
      light: SECONDARY.light,
      main: SECONDARY.main,
      dark: SECONDARY.dark,
      darker: SECONDARY.darker,
      contrastText: '#fff'
    },
    info: {
      lighter: INFO.lighter,
      light: INFO.light,
      main: INFO.main,
      dark: INFO.dark,
      darker: INFO.darker,
      contrastText: '#fff'
    },
    success: {
      lighter: SUCCESS.lighter,
      light: SUCCESS.light,
      main: SUCCESS.main,
      dark: SUCCESS.dark,
      darker: SUCCESS.darker,
      contrastText: GREY[800]
    },
    warning: {
      lighter: WARNING.lighter,
      light: WARNING.light,
      main: WARNING.main,
      dark: WARNING.dark,
      darker: WARNING.darker,
      contrastText: GREY[800]
    },
    error: {
      lighter: ERROR.lighter,
      light: ERROR.light,
      main: ERROR.main,
      dark: ERROR.dark,
      darker: ERROR.darker,
      contrastText: '#fff'
    },
    grey: GREY,
    gradients: GRADIENTS,
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500]
    },
    divider: GREY[50024],
    background: {
      paper: '#fff',
      default: '#fff',
      neutral: GREY[200]
    },
    action: {
      active: GREY[600],
      hover: GREY[5008],
      selected: GREY[50016],
      disabled: GREY[50080],
      disabledBackground: GREY[50024],
      focus: GREY[50024],
      hoverOpacity: 0.08,
      disabledOpacity: 0.48
    }
  },
  // DARK
  dark: {
    mode: 'dark',
    primary: {
      lighter: PRIMARY.lighter,
      light: PRIMARY.light,
      main: PRIMARY.main,
      dark: PRIMARY.dark,
      darker: PRIMARY.darker,
      contrastText: '#fff'
    },
    secondary: {
      lighter: SECONDARY.lighter,
      light: SECONDARY.light,
      main: SECONDARY.main,
      dark: SECONDARY.dark,
      darker: SECONDARY.darker,
      contrastText: '#fff'
    },
    info: {
      lighter: INFO.lighter,
      light: INFO.light,
      main: INFO.main,
      dark: INFO.dark,
      darker: INFO.darker,
      contrastText: '#fff'
    },
    success: {
      lighter: SUCCESS.lighter,
      light: SUCCESS.light,
      main: SUCCESS.main,
      dark: SUCCESS.dark,
      darker: SUCCESS.darker,
      contrastText: GREY[800]
    },
    warning: {
      lighter: WARNING.lighter,
      light: WARNING.light,
      main: WARNING.main,
      dark: WARNING.dark,
      darker: WARNING.darker,
      contrastText: GREY[800]
    },
    error: {
      lighter: ERROR.lighter,
      light: ERROR.light,
      main: ERROR.main,
      dark: ERROR.dark,
      darker: ERROR.darker,
      contrastText: '#fff'
    },
    grey: GREY,
    gradients: GRADIENTS,
    text: {
      primary: '#fff',
      secondary: GREY[500],
      disabled: GREY[600]
    },
    divider: GREY[50024],
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: GREY[50016]
    },
    action: {
      active: GREY[500],
      hover: GREY[5008],
      selected: GREY[50016],
      disabled: GREY[50080],
      disabledBackground: GREY[50024],
      focus: GREY[50024],
      hoverOpacity: 0.08,
      disabledOpacity: 0.48
    }
  }
};